<app-tabla
  [totalCount]="totalCount"
  [datos]="configsEventos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [showHijos]="false"
  [emptyState]="{ title: 'Todavía no hay eventos configurados' }"
></app-tabla>
